module.exports = __webpack_public_path__ + "static/media/roble_estrassburgo.12066e48.jpg";